import {
  DESCRIPTION,
  ID,
  IS_COMMENTABLE,
  MA_ID,
  NAME,
  OPTIONS,
  QUESTION_TYPE,
  QUESTIONS,
  STANDARD_ID,
  STATUS,
} from 'constants/formFields';

import { SURVEY_QUESTION_TYPES } from '../../constants/materialAssessment';

import type { ICreateSurveyRequest, IUpdateSurveyRequest } from 'store/slices/survey/interfaces/ISurveyRequests';
import type { TCreateSurveySchema } from 'utils/validators/MASurveyValidators';

interface IGetRequestDataForSurvey {
  values: TCreateSurveySchema,
  surveyId?: string,
  status: string,
}

function getRequestDataForSurvey({
  values, surveyId, status,
}: IGetRequestDataForSurvey): ICreateSurveyRequest | IUpdateSurveyRequest {
  const baseData = {
    [NAME]: values?.[NAME] || '',
    [DESCRIPTION]: values?.[DESCRIPTION] || '',
    [STATUS]: status,
    [STANDARD_ID]: values?.[STANDARD_ID] || null,
  };

  if (surveyId) {
    return {
      id: Number(surveyId),
      ...baseData,
      [QUESTIONS]: values?.[QUESTIONS]?.map((q) => ({
        ...(q[ID] && { [ID]: q[ID] }),
        [NAME]: q[NAME] || '',
        [QUESTION_TYPE]: q[QUESTION_TYPE] || SURVEY_QUESTION_TYPES.SHORT_ANSWER,
        [OPTIONS]: q[OPTIONS]?.map((opt) => ({
          ...(opt[ID] && { [ID]: opt[ID] }),
          [NAME]: opt[NAME] || '',
        })) || [],
        [IS_COMMENTABLE]: q[IS_COMMENTABLE] || false,
      })) || [],
    } as IUpdateSurveyRequest;
  }

  // For create operations (POST /survey)
  const maId = values?.[MA_ID];
  if (!maId || maId === 0) {
    throw new Error('Materiality assessment is required');
  }

  return {
    ...baseData,
    [MA_ID]: maId,
    [QUESTIONS]: values?.[QUESTIONS]?.map((q) => ({
      [NAME]: q[NAME] || '',
      [QUESTION_TYPE]: q[QUESTION_TYPE] || SURVEY_QUESTION_TYPES.SHORT_ANSWER,
      [OPTIONS]: q[OPTIONS]?.map((opt) => ({
        [NAME]: opt[NAME] || '',
      })) || [],
      [IS_COMMENTABLE]: q[IS_COMMENTABLE] || false,
    })) || [],
  } as ICreateSurveyRequest;
}

export default getRequestDataForSurvey;
